import { render, staticRenderFns } from "./paypal_button.vue?vue&type=template&id=b4a80df0&scoped=true&"
import script from "./paypal_button.vue?vue&type=script&lang=js&"
export * from "./paypal_button.vue?vue&type=script&lang=js&"
import style0 from "./paypal_button.vue?vue&type=style&index=0&id=b4a80df0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a80df0",
  null
  
)

export default component.exports